const initState = {
  notifications: [],
  lastDoc: null,
  hasMoreNotifications: true,
  isFetching: false,
  error: null,
  unreadNotifications: [],
  readNotifications: [],
  lastUnreadDoc: null,
  lastReadDoc: null,
  hasMoreUnread: true,
  hasMoreRead: true,
  isFetchingUnread: false,
  isFetchingRead: false,
  errorUnread: null,
  errorRead: null,
  unreadNotificationsCount: 0,
  isFetchingUnreadCount: false,
  errorUnreadCount: null,
};
const notificationReducer = (state = initState, action) => {
  switch (action.type) {
    case "FETCH_NOTIFICATIONS_PENDING":
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case "FETCH_UNREAD_NOTIFICATIONS_COUNT_PENDING":
      return {
        ...state,
        isFetchingUnreadCount: true,
        errorUnreadCount: null,
      };
    case "FETCH_NOTIFICATIONS_BY_STATUS_PENDING":
      return action.payload.status
        ? { ...state, isFetchingRead: true, errorRead: null }
        : { ...state, isFetchingUnread: true, errorUnread: null };
    case "FETCH_NOTIFICATIONS_SUCCESS":
      return {
        ...state,
        notifications: action.payload.notifications,
        lastDoc: action.payload.lastDoc,
        hasMoreNotifications: action.payload.hasMoreNotifications,
        isFetching: false,
      };
    case "FETCH_NOTIFICATIONS_BY_STATUS_SUCCESS":
      return action.payload.status
        ? {
            ...state,
            readNotifications: action.payload.notifications,
            lastReadDoc: action.payload.lastDoc,
            hasMoreRead: action.payload.hasMoreNotifications,
            isFetchingRead: false,
          }
        : {
            ...state,
            unreadNotifications: action.payload.notifications,
            lastUnreadDoc: action.payload.lastDoc,
            hasMoreUnread: action.payload.hasMoreNotifications,
            isFetchingUnread: false,
          };
    case "FETCH_NOTIFICATIONS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        notifications: [
          ...state.notifications,
          ...action.payload.notifications,
        ],
        lastDoc: action.payload.lastDoc,
        hasMoreNotifications: action.payload.hasMoreNotifications,
        isFetching: false,
      };
    case "FETCH_NOTIFICATIONS_BY_STATUS_LOAD_MORE_SUCCESS":
      return action.payload.status
        ? {
            ...state,
            readNotifications: [
              ...state.readNotifications,
              ...action.payload.notifications,
            ],
            lastReadDoc: action.payload.lastDoc,
            hasMoreRead: action.payload.hasMoreNotifications,
            isFetchingRead: false,
          }
        : {
            ...state,
            unreadNotifications: [
              ...state.unreadNotifications,
              ...action.payload.notifications,
            ],
            lastUnreadDoc: action.payload.lastDoc,
            hasMoreUnread: action.payload.hasMoreNotifications,
            isFetchingUnread: false,
          };
    case "FETCH_UNREAD_NOTIFICATIONS_COUNT_SUCCESS":
      return {
        ...state,
        unreadNotificationsCount: action.payload,
        isFetchingUnreadCount: false,
      };
    case "FETCH_NOTIFICATIONS_REJECTED":
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case "FETCH_UNREAD_NOTIFICATIONS_COUNT_REJECTED":
      return {
        ...state,
        isFetchingUnreadCount: false,
        errorUnreadCount: action.error,
      };
    case "FETCH_NOTIFICATIONS_BY_STATUS_REJECTED":
      return action.payload.status
        ? { ...state, isFetchingRead: false, errorRead: action.error }
        : { ...state, isFetchingUnread: false, errorUnread: action.error };
    default:
      return {
        ...state,
      };
  }
};
export default notificationReducer;
